<template>
  <div class="container">
    <!-- 汇总 -->
    <div class="summary">
      <div class="summary-row">
        <div class="card">
          <div>OPPO今日消耗</div>
          <div class="value">{{ totalCost | currency }}</div>
        </div>
        <div class="card green">
          <div>OPPO昨日消耗</div>
          <div class="value">{{ totalYesterdayCost | currency }}</div>
        </div>
      </div>
      <div class="summary-row">
        <div class="card orange">
          <div>VIVO今日消耗</div>
          <div class="value">{{ vivoTotal | currencyYuan }}</div>
        </div>
        <div class="card purple">
          <div>VIVO昨日消耗</div>
          <div class="value">{{ vivoTotalYesterday | currencyYuan }}</div>
        </div>
      </div>
    </div>

    <!-- 刷新和日期选择 -->
    <div class="refresh">
      <el-button type="primary" size="mini" icon="el-icon-refresh" @click="fetchAllData" :loading="allLoading">
        刷新
      </el-button>
    </div>


    <!-- VIVO数据 -->
    <div class="card-item" v-if="vivoData.length > 0">
      <div class="header">
        <div class="title">VIVO消费数据</div>
        <div class="stats">
          总消费 {{ vivoTotal | currencyYuan }}
        </div>
      </div>
      <div class="table vivo-table">
        <div class="row header-row">
          <div>账户名称</div>
          <div>区域</div>
          <div>今日消费</div>
          <div>昨日消费</div>
        </div>
        <div class="row" v-for="item in vivoData" :key="item.advName">
          <div class="name">{{ item.advName }}</div>
          <div>{{ item.region }}</div>
          <div>{{ item.todayCost | currencyYuan }}</div>
          <div>{{ item.yesterdayCost | currencyYuan }}</div>
        </div>
      </div>
    </div>
    <div v-if="vivoLoading" class="loading">VIVO数据加载中...</div>
    <div v-if="!vivoLoading && vivoData.length === 0" class="loading">暂无VIVO数据</div>
    <!-- 表头 -->
    <div class="table header-fixed">
      <div class="row header-row">
        <div>oppo端口名称</div>
        <div @click="changeSort('todayCashCost')">今日 ⬍</div>
        <div @click="changeSort('yesterdayCost')">昨日 ⬍</div>
        <div @click="changeSort('cashBal')">余额 ⬍</div>
      </div>
    </div>

    <!-- 列表 -->
    <div v-if="loading" class="loading">加载中...</div>

    <div v-else>
      <div v-for="group in groupedList" :key="group.shortName" class="card-item">

        <!-- 分组 -->
        <div class="header">
          <div class="title">{{ group.shortName }}</div>
          <div class="stats">
            今 {{ group.today | currency }} / 昨 {{ group.yesterday | currency }}
          </div>
        </div>

        <!-- 数据 -->
        <div class="table">
          <div class="row" v-for="item in group.items" :key="item.ownerName">
            <div class="name">{{ item.ownerName }}</div>
            <div>{{ item.todayCashCost | currency }}</div>
            <div>{{ item.yesterdayCost | currency }}</div>
            <div :class="{ warn: item.cashBal < 10000 }">
              {{ item.cashBal | currency }}
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    // 设置默认日期为昨天
    const d = new Date()
    d.setDate(d.getDate() - 1)
    return {
      rawData: [],
      groupedList: [],
      loading: false,
      allLoading: false,
      totalCost: 0,
      totalYesterdayCost: 0,
      sortKey: 'todayCashCost',
      sortOrder: 'desc',
      // VIVO数据相关
      vivoData: [],
      vivoLoading: false,
      vivoCookies: [],
      vivoTotal: 0,
      vivoTotalYesterday: 0,
      // 日期选择
      beginTime: d,
      endTime: d
    }
  },

  filters: {
    currency(v) {
      if (!v) return '0.00'
      return (v / 100).toFixed(2)
    },
    currencyYuan(v) {
      if (!v) return '0.00'
      return Number(v).toFixed(2)
    }
  },

  created() {
    this.fetchData()
    this.fetchVivoCookies()
  },

  methods: {
    fetchData() {
      this.loading = true
      return axios.get('https://wcry.zjwec.cn/operation/oppo/project/account/queryMktData', {
        params: { groupName: '张杰组' }
      }).then(res => {
        const data = res.data.data || []
        this.rawData = data
        this.processData()
        this.calc()
        this.$message.success('OPPO数据刷新成功')
        return res
      }).finally(() => {
        this.loading = false
      })
    },

    // 核心处理
    processData() {
      const result = []

      this.rawData.forEach(group => {
        const items = [...group.items]

        // 排序
        items.sort((a, b) => {
          const v1 = a[this.sortKey] || 0
          const v2 = b[this.sortKey] || 0
          return this.sortOrder === 'asc' ? v1 - v2 : v2 - v1
        })

        result.push({
          shortName: group.shortName,
          items,
          today: group.todayCashCostAll || 0,
          yesterday: items.reduce((a, b) => a + (b.yesterdayCost || 0), 0)
        })
      })

      this.groupedList = result
    },

    changeSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'desc'
      }
      this.processData()
    },

    calc() {
      let t = 0, y = 0
      this.rawData.forEach(i => {
        t += i.todayCashCostAll || 0
        i.items.forEach(s => y += s.yesterdayCost || 0)
      })
      this.totalCost = t
      this.totalYesterdayCost = y
    },

    // 格式化日期为yyyy-mm-dd格式（用于VIVO接口）
    formatDate(d) {
      if (!d) return ''
      d = new Date(d)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },

    // 获取VIVO cookie列表
    fetchVivoCookies() {
      const axiosInstance = this.$axios || axios
      axiosInstance.get('https://control.zjwec.cn/api/hdcookie/page', {
        params: {
          pageNum: 1,
          uid: 1,
          role: 1,
          pageSize: 10
        }
      }).then(res => {
        if (res.data.code === "0") {
          this.vivoCookies = res.data.data.records || []
          // 获取到cookies后自动查询昨天的数据
          this.fetchVivoData()
        }
      }).catch(err => {
        console.error('获取VIVO cookies失败:', err)
        this.$message.error('获取VIVO cookies失败')
      })
    },

    // 查询VIVO数据
    fetchVivoData() {
      const axiosInstance = this.$axios || axios
      if (!this.vivoCookies || this.vivoCookies.length === 0) {
        this.vivoLoading = false
        return Promise.resolve()
      }

      this.vivoLoading = true
      // 只过滤出深圳和苏州的cookie
      const targetCookies = this.vivoCookies.filter(cookie =>
        cookie.hdname.includes('深圳') || cookie.hdname.includes('苏州')|| cookie.hdname.includes('广州力天')
      )

      if (targetCookies.length === 0) {
        this.vivoLoading = false
        this.vivoData = []
        return Promise.resolve()
      }

      const reqs = targetCookies.map(cookie => {
        let region = cookie.hdname
        const todayUrl = 'https://control.zjwec.cn/api/vivo/getToDayData'
        const yesterdayUrl = 'https://control.zjwec.cn/api/vivo/getYesDayData'

        const todayPromise = axiosInstance.post(todayUrl, { cookie: cookie.hdcookie })
          .then(res => {
            if (res.data && res.data.retcode === 0 && res.data.data) {
              return Number(res.data.data.totalConsume) || 0
            }
            return 0
          })
          .catch(err => {
            console.error(`VIVO ${cookie.hdname} 今日数据查询失败:`, err)
            return 0
          })

        const yesterdayPromise = axiosInstance.post(yesterdayUrl, { cookie: cookie.hdcookie })
          .then(res => {
            if (res.data && res.data.retcode === 0 && res.data.data) {
              return Number(res.data.data.totalConsume) || 0
            }
            return 0
          })
          .catch(err => {
            console.error(`VIVO ${cookie.hdname} 昨日数据查询失败:`, err)
            return 0
          })

        return Promise.all([todayPromise, yesterdayPromise]).then(([todayCost, yesterdayCost]) => {
          return {
            advName: `VIVO-${cookie.hdname}`,
            todayCost: todayCost,
            yesterdayCost: yesterdayCost,
            region: region
          }
        })
      })

      return Promise.all(reqs).then(res => {
        this.vivoData = res
        this.vivoLoading = false
        this.calcVivoTotal()
        this.$message.success('VIVO数据刷新成功')
        return res
      })
    },

    // 计算VIVO总计
    calcVivoTotal() {
      let todayTotal = 0
      let yesterdayTotal = 0
      this.vivoData.forEach(item => {
        todayTotal += Number(item.todayCost) || 0
        yesterdayTotal += Number(item.yesterdayCost) || 0
      })
      this.vivoTotal = todayTotal
      this.vivoTotalYesterday = yesterdayTotal
    },

    // 刷新所有数据
    fetchAllData() {
      this.allLoading = true
      Promise.all([
        this.fetchData(),
        this.fetchVivoData()
      ]).finally(() => {
        this.allLoading = false
      })
    }
  }
}
</script>

<style scoped>
.container {
  padding: 10px;
  background: #f5f6f8;
}

/* 汇总 */
.summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}
.summary-row {
  display: flex;
  gap: 12px;
}
.card {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, #1890ff, #36cfc9);
  color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.card.green {
  background: linear-gradient(135deg, #52c41a, #95de64);
}
.card.orange {
  background: linear-gradient(135deg, #fa8c16, #ffc069);
}
.card.purple {
  background: linear-gradient(135deg, #722ed1, #b37feb);
}
.value {
  font-size: 18px;
  font-weight: bold;
}

/* 刷新 */
.refresh {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

/* 表头 */
.header-fixed {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

/* 卡片 */
.card-item {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}
.card-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

/* 分组头 */
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.title {
  font-weight: bold;
}
.stats {
  font-size: 12px;
  color: #666;
}

/* 表格 */
.table {
  font-size: 12px;
}
.row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 8px 6px;
  border-bottom: 1px solid #eee;
}
.vivo-table .row {
  grid-template-columns: 2fr 1fr 1fr 1fr;
}
.header-row {
  font-weight: bold;
  background: linear-gradient(135deg, #f5f7fa, #e4e7ed);
  color: #333;
}

/* 文本 */
.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 预警 */
.warn {
  color: red;
  font-weight: bold;
}

/* 查询表单 */
.query-form {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

/* loading */
.loading {
  text-align: center;
  padding: 30px;
  color: #666;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/oppo/data/ZhangjieData.vue